import React from 'react';
import Body from './Body';

const Edit = (props) => {
  return <Body {...props} isEditMode={true} />;
};

export default Edit;
